export default __webpack_public_path__ + "static/media/personal.f9576f84.png";